import 'moment/locale/ko';
import moment from 'moment/moment';

export const dateFormats = {
  'YYYY년 M월 D일': 'YYYY년 M월 D일',
  'YYYY년 M월 D일(dd)': 'YYYY년 M월 D일(dd)',
  'YYYY년 M월 D일 A h시 m분': 'YYYY년 M월 D일 A h시 m분',
} as const;

export const formatDate = (date: Date, format: keyof typeof dateFormats): string => {
  return moment(date).format(format);
};
